import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { IonReactRouter } from '@ionic/react-router';
import LandingPage from '../pages/LandingPage';
import PrivacyPage from '../pages/Privacy';
import ChooseLang from './ChooseLang';
import Page from '../pages/Page';
import { useGlobalStore } from './stateManagement/globalZustand';
import URLImport from './URLImport';
import SuccessPage from './Success';
import Logout from './Logout';
import DragAndDrop from './DragAndDrop';
import Activities from './Activities';
import URLManager from './default/URLManager';
import { _homeNodePath } from './constants';
import Activity from './Activity';
import Login from '../pages/Login';
import Stories from './Stories';
import Homeworks from './Homeworks';
import AutoQuiz from './AutoQuiz';
import TemplateQ1 from './quiz/TemplateQ1';
import PricingPage from '../pages/PricingPage';
import ProblemReportPage from '../pages/ProblemReportPage';



const Routing: React.FC = () => {
    const { hasChosenLang } = useGlobalStore();
    // If this is rendered, it means variables were already
    // initialized, otherwise AppRoot would not proceed to render

    
    return (
        <IonReactRouter>
            <Switch>
                <Route path="/success" exact={true}><SuccessPage /></Route>
                <Route path="/logout" exact={true}><Logout /></Route>
                <Route path="/privacy" exact={true}><PrivacyPage /></Route>
                <Route path="/welcome" exact={true}><LandingPage /></Route>
                <Route path="/lang" exact={true}><ChooseLang /></Route>
                <Route path="/pricing" exact={true}><PricingPage /></Route>
                <Route path="/login" exact={true}><Login /></Route>
                <Route path="/report" exact={true}><ProblemReportPage /></Route>

                <Route path="/page/:section(quiz|talk|bulkImport)/:nodePath?" exact={true}>
                    <URLManager />
                    <Page />
                </Route>
                <Route path="/:section(task)/1/:mainImageLabel/:nodePath" exact={true}>
                    <URLManager />
                    <TemplateQ1 />
                </Route>
                <Route path="/import/:labels" exact={true}>
                    <URLManager />
                    <URLImport />
                </Route>
                <Route path="/drop/:nodePath" exact={true}>
                    <URLManager />
                    <DragAndDrop />
                </Route>
                <Route path="/activities" exact={true}>
                    <URLManager />
                    <Activities />
                </Route>
                <Route path="/homeworks" exact={true}>
                    <URLManager />
                    <Homeworks />
                </Route>
                <Route path="/autoquiz/:nodePath" exact={true}>
                    <URLManager />
                    <AutoQuiz />
                </Route>

                <Route path="/stories" exact={true}>
                    <URLManager />
                    <Stories />
                </Route>
                <Route path="/activity/:templateCode/:activityCode" exact={true}>
                    <URLManager />
                    <Activity />
                </Route>


                <Route><Redirect to={"/page/talk/" + _homeNodePath} /></Route>
            </Switch>
        </IonReactRouter>
    );
}





export default Routing;
